import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CONSENT_KEY = "mfx_analytics_consent";

export function getAnalyticsConsent(): boolean {
  return localStorage.getItem(CONSENT_KEY) === "true";
}

export function hasRespondedToConsent(): boolean {
  return localStorage.getItem(CONSENT_KEY) !== null;
}

export function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show banner if user hasn't responded yet
    if (!hasRespondedToConsent()) {
      // Small delay so it doesn't flash on page load
      const t = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  if (!visible) return null;

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, "true");
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, "false");
    setVisible(false);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6">
      <div className="max-w-lg mx-auto bg-dark-800 border border-white/10 rounded-2xl shadow-elevated px-5 py-4">
        <p className="text-body-sm text-dark-200 mb-3">
          We use analytics to understand how you use the platform and to improve your experience. No data is shared with third parties.{" "}
          <Link to="/privacy-policy" className="text-brand-400 underline underline-offset-2">
            Privacy Policy
          </Link>
        </p>
        <div className="flex items-center gap-3">
          <button
            onClick={handleAccept}
            className="flex-1 px-4 py-2 rounded-xl bg-brand-500 text-white text-caption font-semibold hover:bg-brand-600 transition-colors"
          >
            Accept
          </button>
          <button
            onClick={handleDecline}
            className="flex-1 px-4 py-2 rounded-xl bg-white/5 text-dark-300 text-caption font-semibold hover:bg-white/10 transition-colors"
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
}
